import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import SafeComponent from '../../shared/SafeComponent';
import VideoHeroBanner from '../VideoHeroBanner';
import Hero from '../Hero';
import { useIsMobileLayout } from '../../../../shared/hooks/useIsMobileLayout';

const VideoHeroBannerWrapper = () => {
    const isMobileLayout = useIsMobileLayout(['default', 'sm']);

    return <Container>{isMobileLayout ? <Hero /> : <VideoHeroBanner />}</Container>;
};

export default SafeComponent(VideoHeroBannerWrapper);
